export const WHEEL_COEF = 2.54;
